(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-p2a-lab"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('test-p2a-counter')) {
  customElements.define('test-p2a-counter', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      clearTimeout(this.expiryTimer);
      const signal = this.abort.signal;
      this.querySelector('button').addEventListener('click', () => {
        const out = this.querySelector('output'); out.value = String(Number(out.value) + 1);
      }, {signal});
      const root = this.closest('.test-p2a');
      const select = root.querySelector('[data-service]');
      if (!select) return;
      const form = select.form;
      const state = root.querySelector('[data-contact-state]')?.dataset.contactState;
      const codes = ['oem','sourcing','trade','market-entry','digital','creative','other'];
      const names = ['company','name','email','phone','body','service','context'];
      const field = name => form.elements.namedItem('contact[' + name + ']');
      const key = 'TEST-P2A-R1:' + location.pathname + ':' + root.id;
      const ttl = 10 * 60 * 1000;
      const note = root.querySelector('[data-recovery-note]');
      const remove = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
      let saved;
      try {
        saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (!saved || !Number.isFinite(saved.at) || Date.now() - saved.at >= ttl || saved.at > Date.now() || !saved.values || !codes.includes(saved.values.service)) { remove(); saved = null; }
      } catch (_) { remove(); saved = null; }
      if (state === 'success') { remove(); saved = null; }
      if (!select.dataset.initialized) {
        select.dataset.initialized = 'true';
        if (state === 'error') {
          if (saved) {
            names.forEach(name => { if (field(name) && typeof saved.values[name] === 'string') field(name).value = saved.values[name]; });
            note.textContent = '前回の入力を復元しました。内容と同意を再確認してください。';
          } else {
            note.textContent = '復元データがありません。会社名・氏名・電話・分類を含め、入力を再確認してください。';
          }
          field('privacy_consent').checked = false;
          remove();
        } else if (state !== 'success' && !select.value) {
          const code = new URLSearchParams(location.search).get('service');
          if (codes.includes(code)) select.value = code;
        }
      }
      const updateContext = () => {
        const ec = select.value === 'sourcing' && (field('context').value === 'ec' || (state === 'initial' && new URLSearchParams(location.search).get('context') === 'ec'));
        root.querySelector('[data-context]').hidden = !ec;
        field('context').value = ec ? 'ec' : '';
      };
      updateContext();
      select.addEventListener('change', updateContext, {signal});
      if (saved && state !== 'error') this.expiryTimer = setTimeout(remove, Math.max(0, ttl - (Date.now() - saved.at)));
      form.addEventListener('submit', () => {
        const values = Object.fromEntries(names.map(name => [name, field(name)?.value || '']));
        try {
          sessionStorage.setItem(key, JSON.stringify({at:Date.now(),values}));
          clearTimeout(this.expiryTimer); this.expiryTimer = setTimeout(remove, ttl);
        } catch (_) { note.textContent = '一時保存を利用できません。送信エラー時は再入力が必要です。'; }
      }, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.expiryTimer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
